var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 184,
    viewBox: "0 0 286 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M169 172.7L15.9999 84.3C14.1999 83.3 14.3999 81.5 16.4999 80.3L107.7 27.6C109.8 26.4 112.9 26.3 114.6 27.3L267.6 115.7C269.4 116.7 269.2 118.5 267.1 119.7L175.9 172.4C173.9 173.6 170.8 173.7 169 172.7Z",
    fill: "#01342D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.2 183.1C170.8 183.1 169.5 182.8 168.5 182.2L1.6 85.7999C0.6 85.1999 0 84.2999 0 83.3999C0 82.2999 0.8 81.1999 2.2 80.3999L108.3 19.0999C110.8 17.6999 114.6 17.4999 116.8 18.7999L283.7 115.2C284.7 115.8 285.3 116.7 285.3 117.6C285.3 118.7 284.5 119.8 283.1 120.6L177 181.9C175.7 182.7 173.9 183.1 172.2 183.1ZM169 181.5C170.9 182.6 174.4 182.5 176.6 181.2L282.7 119.9C283.8 119.3 284.5 118.4 284.5 117.6C284.5 117 284.1 116.4 283.3 116L116.4 19.5999C114.5 18.4999 111 18.5999 108.8 19.8999L2.6 81.1999C1.5 81.7999 0.8 82.6999 0.8 83.4999C0.8 84.0999 1.2 84.6999 2 85.0999L169 181.5Z",
    fill: "#B7E9E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M275.2 92.7998L268.9 93.8998L118.9 7.29979C117 6.19979 113.8 6.39979 111.7 7.59979L25.9 57.1998L14.8 59.0998V62.6998C14.8 63.3998 15.2 64.0998 16 64.5998L171 154.1C172.9 155.2 176.1 155 178.2 153.8L273.3 98.8998C274.5 98.1998 275.1 97.3998 275.1 96.4998V92.7998H275.2Z",
    fill: "#258D81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M275.2 92.7998L268.9 93.8998L118.9 7.29979C117 6.19979 113.8 6.39979 111.7 7.59979L25.9 57.1998L14.8 59.0998V62.6998C14.8 63.3998 15.2 64.0998 16 64.5998L171 154.1C172.9 155.2 176.1 155 178.2 153.8L273.3 98.8998C274.5 98.1998 275.1 97.3998 275.1 96.4998V92.7998H275.2Z",
    fill: "url(#paint0_radial)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M273.5 96.7004L178.4 151.6C176.3 152.8 173 153 171.2 151.9L16.0002 62.3004C15.1002 61.8004 14.7002 61.1004 14.8002 60.4004V61.3004C14.8002 62.0004 15.2002 62.7004 16.0002 63.2004L171 152.7C172.9 153.8 176.1 153.6 178.2 152.4L273.3 97.5004C274.5 96.8004 275.1 96.0004 275.1 95.1004V94.2004C275.2 95.1004 274.6 96.0004 273.5 96.7004Z",
    fill: "url(#paint1_radial)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M171.1 150.4L16.0001 60.9C14.1001 59.8 14.4001 58 16.5001 56.7L111.6 1.79999C113.7 0.599986 117 0.399986 118.8 1.49999L274 91C275.9 92.1 275.6 93.9 273.5 95.2L178.4 150.1C176.2 151.4 172.9 151.5 171.1 150.4Z",
    fill: "#258D81"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M171.1 150.4L16.0001 60.9C14.1001 59.8 14.4001 58 16.5001 56.7L111.6 1.79999C113.7 0.599986 117 0.399986 118.8 1.49999L274 91C275.9 92.1 275.6 93.9 273.5 95.2L178.4 150.1C176.2 151.4 172.9 151.5 171.1 150.4Z",
    fill: "url(#paint2_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M275.2 92.1006L268.9 93.2006L118.9 6.60057C117 5.50057 113.8 5.70057 111.7 6.90057L25.9 56.4006L14.8 58.3006V59.0006C14.8 59.7006 15.2 60.4006 16 60.9006L171 150.401C172.9 151.501 176.1 151.301 178.2 150.101L273.3 95.2006C274.5 94.5006 275.1 93.7006 275.1 92.8006V92.1006H275.2Z",
    fill: "url(#paint3_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M171.1 149.7L16.0001 60.1002C14.1001 59.0002 14.4001 57.2002 16.5001 55.9002L111.7 1.00018C113.8 -0.199818 117.1 -0.399818 118.9 0.700182L273.9 90.2002C275.8 91.3002 275.5 93.1002 273.4 94.4002L178.3 149.3C176.2 150.6 172.9 150.8 171.1 149.7Z",
    fill: "url(#paint4_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M171.1 149.7L16.0001 60.1002C14.1001 59.0002 14.4001 57.2002 16.5001 55.9002L111.7 1.00018C113.8 -0.199818 117.1 -0.399818 118.9 0.700182L273.9 90.2002C275.8 91.3002 275.5 93.1002 273.4 94.4002L178.3 149.3C176.2 150.6 172.9 150.8 171.1 149.7Z",
    fill: "#258D81"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M171.1 149.7L16.0001 60.1002C14.1001 59.0002 14.4001 57.2002 16.5001 55.9002L111.7 1.00018C113.8 -0.199818 117.1 -0.399818 118.9 0.700182L273.9 90.2002C275.8 91.3002 275.5 93.1002 273.4 94.4002L178.3 149.3C176.2 150.6 172.9 150.8 171.1 149.7Z",
    fill: "url(#paint5_radial)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M171.1 149.7L16.0001 60.1002C14.1001 59.0002 14.4001 57.2002 16.5001 55.9002L111.7 1.00018C113.8 -0.199818 117.1 -0.399818 118.9 0.700182L273.9 90.2002C275.8 91.3002 275.5 93.1002 273.4 94.4002L178.3 149.3C176.2 150.6 172.9 150.8 171.1 149.7Z",
    fill: "url(#paint6_radial)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M171.9 149.6L16.9001 60.1C14.9001 58.9 14.5001 57.6 17.4001 55.9L112.6 1C113.6 0.4 114.7 0.1 115.9 0C114.4 0 112.9 0.3 111.7 1L16.5001 56C14.4001 57.2 14.1001 59.1 16.0001 60.2L171 149.7C172 150.3 173.5 150.5 174.9 150.4C173.8 150.4 172.8 150.1 171.9 149.6Z",
    fill: "url(#paint7_radial)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M260.7 96.8002C261.3 97.1002 261.3 97.7002 260.7 98.0002C260.1 98.3002 259.2 98.3002 258.7 98.0002C258.1 97.7002 258.1 97.1002 258.7 96.8002C259.3 96.5002 260.2 96.5002 260.7 96.8002Z",
    fill: "#F9F9F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M263.9 95.0002C264.5 95.3002 264.5 95.9002 263.9 96.2002C263.3 96.5002 262.4 96.5002 261.9 96.2002C261.3 95.9002 261.3 95.3002 261.9 95.0002C262.4 94.6002 263.4 94.6002 263.9 95.0002Z",
    fill: "#F9F9F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M267.1 93.1C267.7 93.4 267.7 94 267.1 94.3C266.5 94.6 265.6 94.6 265.1 94.3C264.5 94 264.5 93.4 265.1 93.1C265.6 92.8 266.5 92.8 267.1 93.1Z",
    fill: "#F9F9F9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M212.8 132.2C212.8 132.6 213.1 132.7 213.4 132.6C213.7 132.4 214 131.9 214 131.5C214 131.1 213.7 131 213.4 131.1C213.1 131.3 212.8 131.8 212.8 132.2Z",
    fill: "#013F37"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M210.4 133.6C210.4 134 210.7 134.1 211 134C211.3 133.8 211.6 133.3 211.6 132.9C211.6 132.5 211.3 132.4 211 132.5C210.7 132.7 210.4 133.2 210.4 133.6Z",
    fill: "#013F37"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M208 134.9C208 135.3 208.3 135.4 208.6 135.3C208.9 135.1 209.2 134.6 209.2 134.2C209.2 133.8 208.9 133.7 208.6 133.8C208.3 134.1 208 134.6 208 134.9Z",
    fill: "#013F37"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M245.8 113.1C245.8 113.5 246.1 113.6 246.4 113.5C246.7 113.3 247 112.8 247 112.4C247 112 246.7 111.9 246.4 112C246.1 112.3 245.8 112.8 245.8 113.1Z",
    fill: "#013F37"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M243.4 114.5C243.4 114.9 243.7 115 244 114.9C244.3 114.7 244.6 114.2 244.6 113.8C244.6 113.4 244.3 113.3 244 113.4C243.7 113.7 243.4 114.1 243.4 114.5Z",
    fill: "#013F37"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M241 115.9C241 116.3 241.3 116.4 241.6 116.3C241.9 116.2 242.2 115.6 242.2 115.2C242.2 114.8 241.9 114.7 241.6 114.8C241.3 115.1 241 115.5 241 115.9Z",
    fill: "#013F37"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M224.7 125.3C224.7 125.8 225 126 225.4 125.8L229.6 123.3C230 123.1 230.3 122.5 230.3 122.1C230.3 121.6 230 121.4 229.6 121.6L225.4 124.1C225 124.3 224.7 124.8 224.7 125.3Z",
    fill: "#013F37"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8001 69.1002L76.6001 65.5002L91.0001 57.2002L97.2001 60.8002L82.8001 69.1002Z",
    fill: "#9BE7DD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2 75.0998L87 71.4998L110.8 57.7998L116.9 61.3998L93.2 75.0998Z",
    fill: "#9BE7DD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.6 81.1002L97.4001 77.5002L119.5 64.7002L125.7 68.3002L103.6 81.1002Z",
    fill: "#9BE7DD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M114 87.1002L107.8 83.5002L136 67.2002L142.1 70.8002L114 87.1002Z",
    fill: "#9BE7DD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M124.3 93.1006L118.2 89.5006L153.4 69.1006L159.6 72.7006L124.3 93.1006Z",
    fill: "#9BE7DD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M134.7 99.1004L128.6 95.5004L158.1 78.4004L164.3 82.0004L134.7 99.1004Z",
    fill: "#9BE7DD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M145.1 105.1L139 101.5L185.4 74.7002L191.6 78.2002L145.1 105.1Z",
    fill: "#9BE7DD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M155.5 111L149.3 107.5L204.3 75.7998L210.4 79.2998L155.5 111Z",
    fill: "#9BE7DD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M120.5 58.1C119.5 58.1 118.5 57.9 117.8 57.4C117 56.9 116.6 56.3 116.6 55.6C116.6 54.9 117 54.3 117.8 53.8C119.3 52.9 121.7 52.9 123.3 53.8C124.1 54.3 124.5 54.9 124.5 55.6C124.5 56.3 124.1 56.9 123.3 57.4C122.5 57.9 121.5 58.1 120.5 58.1ZM120.5 53.9C119.6 53.9 118.8 54.1 118.1 54.5C117.5 54.8 117.2 55.3 117.2 55.7C117.2 56.1 117.5 56.6 118.1 56.9C119.4 57.7 121.6 57.7 122.9 56.9C123.5 56.6 123.8 56.1 123.8 55.7C123.8 55.3 123.5 54.8 122.9 54.5C122.3 54.1 121.4 53.9 120.5 53.9Z",
    fill: "#88DBD1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 57.5004C99.8001 57.5004 98.8001 57.3004 98.1001 56.8004C97.3001 56.3004 96.9001 55.7004 96.9001 55.0004C96.9001 54.3004 97.3001 53.7004 98.1001 53.2004C99.6001 52.3004 102 52.3004 103.6 53.2004C104.4 53.7004 104.8 54.3004 104.8 55.0004C104.8 55.7004 104.4 56.3004 103.6 56.8004C102.8 57.3004 101.8 57.5004 100.8 57.5004ZM100.8 53.3004C99.9001 53.3004 99.1001 53.5004 98.4001 53.9004C97.8001 54.2004 97.5001 54.7004 97.5001 55.1004C97.5001 55.5004 97.8001 56.0004 98.4001 56.3004C99.7001 57.1004 101.9 57.1004 103.2 56.3004C103.8 56.0004 104.1 55.5004 104.1 55.1004C104.1 54.7004 103.8 54.2004 103.2 53.9004C102.6 53.5004 101.7 53.3004 100.8 53.3004Z",
    fill: "#88DBD1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M129.3 65.1C128.3 65.1 127.3 64.9 126.6 64.4C125.8 63.9 125.4 63.3 125.4 62.6C125.4 61.9 125.8 61.3 126.6 60.8C128.1 59.9 130.5 59.9 132.1 60.8C132.9 61.3 133.3 61.9 133.3 62.6C133.3 63.3 132.9 63.9 132.1 64.4C131.3 64.9 130.3 65.1 129.3 65.1ZM129.3 60.9C128.4 60.9 127.6 61.1 126.9 61.5C126.3 61.8 126 62.3 126 62.7C126 63.1 126.3 63.6 126.9 63.9C128.2 64.7 130.4 64.7 131.7 63.9C132.3 63.6 132.6 63.1 132.6 62.7C132.6 62.3 132.3 61.8 131.7 61.5C131 61.1 130.2 60.9 129.3 60.9Z",
    fill: "#88DBD1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M145.7 67.6C144.7 67.6 143.7 67.4 143 66.9C142.2 66.4 141.8 65.8 141.8 65.1C141.8 64.4 142.2 63.8 143 63.3C144.5 62.4 146.9 62.4 148.5 63.3C149.3 63.8 149.7 64.4 149.7 65.1C149.7 65.8 149.3 66.4 148.5 66.9C147.7 67.4 146.7 67.6 145.7 67.6ZM145.7 63.4C144.8 63.4 144 63.6 143.3 64C142.7 64.3 142.4 64.8 142.4 65.2C142.4 65.6 142.7 66.1 143.3 66.4C144.6 67.2 146.8 67.2 148.1 66.4C148.7 66.1 149 65.6 149 65.2C149 64.8 148.7 64.3 148.1 64C147.5 63.6 146.6 63.4 145.7 63.4Z",
    fill: "#88DBD1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M163.2 69.5004C162.2 69.5004 161.2 69.3004 160.5 68.8004C159.7 68.3004 159.3 67.7004 159.3 67.0004C159.3 66.3004 159.7 65.7004 160.5 65.2004C162 64.3004 164.4 64.3004 166 65.2004C166.8 65.7004 167.2 66.3004 167.2 67.0004C167.2 67.7004 166.8 68.3004 166 68.8004C165.2 69.3004 164.2 69.5004 163.2 69.5004ZM163.2 65.3004C162.3 65.3004 161.5 65.5004 160.8 65.9004C160.2 66.2004 159.9 66.7004 159.9 67.1004C159.9 67.5004 160.2 68.0004 160.8 68.3004C162.1 69.1004 164.3 69.1004 165.6 68.3004C166.2 68.0004 166.5 67.5004 166.5 67.1004C166.5 66.7004 166.2 66.2004 165.6 65.9004C164.9 65.5004 164.1 65.3004 163.2 65.3004Z",
    fill: "#88DBD1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M167.9 78.8002C166.9 78.8002 165.9 78.6002 165.2 78.1002C164.4 77.6002 164 77.0002 164 76.3002C164 75.6002 164.4 75.0002 165.2 74.5002C166.7 73.6002 169.1 73.6002 170.7 74.5002C171.5 75.0002 171.9 75.6002 171.9 76.3002C171.9 77.0002 171.5 77.6002 170.7 78.1002C169.8 78.6002 168.9 78.8002 167.9 78.8002ZM167.9 74.6002C167 74.6002 166.2 74.8002 165.5 75.2002C164.9 75.5002 164.6 76.0002 164.6 76.4002C164.6 76.8002 164.9 77.3002 165.5 77.6002C166.8 78.4002 169 78.4002 170.3 77.6002C170.9 77.3002 171.2 76.8002 171.2 76.4002C171.2 76.0002 170.9 75.5002 170.3 75.2002C169.6 74.8002 168.7 74.6002 167.9 74.6002Z",
    fill: "#88DBD1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M195.2 75.0004C194.2 75.0004 193.2 74.8004 192.5 74.3004C191.7 73.8004 191.3 73.2004 191.3 72.5004C191.3 71.8004 191.7 71.2004 192.5 70.7004C194 69.8004 196.4 69.8004 198 70.7004C198.8 71.2004 199.2 71.8004 199.2 72.5004C199.2 73.2004 198.8 73.8004 198 74.3004C197.2 74.8004 196.2 75.0004 195.2 75.0004ZM195.2 70.8004C194.3 70.8004 193.5 71.0004 192.8 71.4004C192.2 71.7004 191.9 72.2004 191.9 72.6004C191.9 73.0004 192.2 73.5004 192.8 73.8004C194.1 74.6004 196.3 74.6004 197.6 73.8004C198.2 73.5004 198.5 73.0004 198.5 72.6004C198.5 72.2004 198.2 71.7004 197.6 71.4004C196.9 71.0004 196.1 70.8004 195.2 70.8004Z",
    fill: "#88DBD1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M214 76.1C213 76.1 212 75.9 211.3 75.4C210.5 74.9 210.1 74.3 210.1 73.6C210.1 72.9 210.5 72.3 211.3 71.8C212.8 70.9 215.2 70.9 216.8 71.8C217.6 72.3 218 72.9 218 73.6C218 74.3 217.6 74.9 216.8 75.4C216 75.9 215 76.1 214 76.1ZM214 71.9C213.1 71.9 212.3 72.1 211.6 72.5C211 72.8 210.7 73.3 210.7 73.7C210.7 74.1 211 74.6 211.6 74.9C212.9 75.7 215.1 75.7 216.4 74.9C217 74.6 217.3 74.1 217.3 73.7C217.3 73.3 217 72.8 216.4 72.5C215.8 72.1 214.9 71.9 214 71.9Z",
    fill: "#88DBD1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M210.4 73.8004L198.8 73.1004C198.6 73.1004 198.5 72.9004 198.5 72.7004C198.5 72.5004 198.6 72.4004 198.9 72.4004L210.5 73.1004C210.7 73.1004 210.8 73.3004 210.8 73.5004C210.8 73.7004 210.6 73.8004 210.4 73.8004Z",
    fill: "#88DBD1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M171.4 76.2002C171.2 76.2002 171.1 76.1002 171.1 75.9002C171.1 75.7002 171.2 75.6002 171.4 75.5002L191.7 72.7002C191.9 72.7002 192 72.8002 192.1 73.0002C192.1 73.2002 192 73.3002 191.8 73.4002L171.4 76.2002Z",
    fill: "#88DBD1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M166.9 74.7002C166.8 74.7002 166.7 74.6002 166.6 74.5002L164 69.2002C163.9 69.0002 164 68.8002 164.1 68.8002C164.3 68.7002 164.5 68.8002 164.5 68.9002L167.1 74.2002C167.2 74.4002 167.1 74.6002 167 74.6002C167 74.7002 166.9 74.7002 166.9 74.7002Z",
    fill: "#88DBD1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M159.6 67.0002L149.2 65.9002C149 65.9002 148.9 65.7002 148.9 65.5002C148.9 65.3002 149.1 65.2002 149.3 65.2002L159.6 66.3002C159.8 66.3002 159.9 66.5002 159.9 66.7002C159.9 66.9002 159.8 67.0002 159.6 67.0002Z",
    fill: "#88DBD1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M142.2 65.0004C142.2 65.0004 142.2 64.9004 142.2 65.0004L132.7 63.6004C132.5 63.6004 132.4 63.4004 132.4 63.2004C132.4 63.0004 132.6 62.9004 132.8 62.9004L142.2 64.3004C142.4 64.3004 142.5 64.5004 142.5 64.7004C142.5 64.8004 142.4 65.0004 142.2 65.0004Z",
    fill: "#88DBD1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M127.1 61.3C127 61.3 127 61.3 126.9 61.2L122.5 57.7C122.4 57.6 122.3 57.4 122.4 57.2C122.5 57.1 122.7 57 122.9 57.1L127.3 60.6C127.4 60.7 127.5 60.9 127.4 61.1C127.3 61.2 127.2 61.3 127.1 61.3Z",
    fill: "#88DBD1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M116.9 55.9004L104.4 55.5004C104.2 55.5004 104.1 55.3004 104.1 55.2004C104.1 55.0004 104.3 54.9004 104.4 54.9004L116.9 55.3004C117.1 55.3004 117.2 55.5004 117.2 55.6004C117.2 55.8004 117.1 55.9004 116.9 55.9004Z",
    fill: "#88DBD1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M104.1 67.6C103.1 67.6 102.1 67.4 101.4 66.9C100.6 66.4 100.2 65.8 100.2 65.1C100.2 64.4 100.6 63.8 101.4 63.3C102.9 62.4 105.3 62.4 106.9 63.3C107.7 63.8 108.1 64.4 108.1 65.1C108.1 65.8 107.7 66.4 106.9 66.9C106.1 67.4 105.1 67.6 104.1 67.6ZM104.1 63.4C103.2 63.4 102.4 63.6 101.7 64C101.1 64.3 100.8 64.8 100.8 65.2C100.8 65.6 101.1 66.1 101.7 66.4C103 67.2 105.2 67.2 106.5 66.4C107.1 66.1 107.4 65.6 107.4 65.2C107.4 64.8 107.1 64.3 106.5 64C105.9 63.6 105 63.4 104.1 63.4Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4 67.0004C83.4 67.0004 82.4 66.8004 81.7 66.3004C80.9 65.8004 80.5 65.2004 80.5 64.5004C80.5 63.8004 80.9 63.2004 81.7 62.7004C83.2 61.8004 85.6 61.8004 87.2 62.7004C88 63.2004 88.4 63.8004 88.4 64.5004C88.4 65.2004 88 65.8004 87.2 66.3004C86.4 66.8004 85.4 67.0004 84.4 67.0004ZM84.4 62.8004C83.5 62.8004 82.7 63.0004 82 63.4004C81.4 63.7004 81.1 64.2004 81.1 64.6004C81.1 65.0004 81.4 65.5004 82 65.8004C83.3 66.6004 85.5 66.6004 86.8 65.8004C87.4 65.5004 87.7 65.0004 87.7 64.6004C87.7 64.2004 87.4 63.7004 86.8 63.4004C86.2 63.0004 85.3 62.8004 84.4 62.8004Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M112.9 74.6C111.9 74.6 110.9 74.4 110.2 73.9C109.4 73.4 109 72.8 109 72.1C109 71.4 109.4 70.8 110.2 70.3C111.7 69.4 114.1 69.4 115.7 70.3C116.5 70.8 116.9 71.4 116.9 72.1C116.9 72.8 116.5 73.4 115.7 73.9C114.9 74.3 113.9 74.6 112.9 74.6ZM112.9 70.4C112 70.4 111.2 70.6 110.5 71C109.9 71.3 109.6 71.8 109.6 72.2C109.6 72.6 109.9 73.1 110.5 73.4C111.8 74.2 114 74.2 115.3 73.4C115.9 73.1 116.2 72.6 116.2 72.2C116.2 71.8 115.9 71.3 115.3 71C114.6 70.5 113.8 70.4 112.9 70.4Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M129.3 77.1C128.3 77.1 127.3 76.9 126.6 76.4C125.8 75.9 125.4 75.3 125.4 74.6C125.4 73.9 125.8 73.3 126.6 72.8C128.1 71.9 130.5 71.9 132.1 72.8C132.9 73.3 133.3 73.9 133.3 74.6C133.3 75.3 132.9 75.9 132.1 76.4C131.3 76.8 130.3 77.1 129.3 77.1ZM129.3 72.8C128.4 72.8 127.6 73 126.9 73.4C126.3 73.7 126 74.2 126 74.6C126 75 126.3 75.5 126.9 75.8C128.2 76.6 130.4 76.6 131.7 75.8C132.3 75.5 132.6 75 132.6 74.6C132.6 74.2 132.3 73.7 131.7 73.4C131.1 73 130.2 72.8 129.3 72.8Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M146.8 79.0004C145.8 79.0004 144.8 78.8004 144.1 78.3004C143.3 77.8004 142.9 77.2004 142.9 76.5004C142.9 75.8004 143.3 75.2004 144.1 74.7004C145.6 73.8004 148 73.8004 149.6 74.7004C150.4 75.2004 150.8 75.8004 150.8 76.5004C150.8 77.2004 150.4 77.8004 149.6 78.3004C148.8 78.7004 147.8 79.0004 146.8 79.0004ZM146.8 74.8004C145.9 74.8004 145.1 75.0004 144.4 75.4004C143.8 75.7004 143.5 76.2004 143.5 76.6004C143.5 77.0004 143.8 77.5004 144.4 77.8004C145.7 78.6004 147.9 78.6004 149.2 77.8004C149.8 77.5004 150.1 77.0004 150.1 76.6004C150.1 76.2004 149.8 75.7004 149.2 75.4004C148.5 74.9004 147.7 74.8004 146.8 74.8004Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M151.5 88.3002C150.5 88.3002 149.5 88.1002 148.8 87.6002C148 87.1002 147.6 86.5002 147.6 85.8002C147.6 85.1002 148 84.5002 148.8 84.0002C150.3 83.1002 152.7 83.1002 154.3 84.0002C155.1 84.5002 155.5 85.1002 155.5 85.8002C155.5 86.5002 155.1 87.1002 154.3 87.6002C153.4 88.0002 152.5 88.3002 151.5 88.3002ZM151.5 84.1002C150.6 84.1002 149.8 84.3002 149.1 84.7002C148.5 85.0002 148.2 85.5002 148.2 85.9002C148.2 86.3002 148.5 86.8002 149.1 87.1002C150.4 87.9002 152.6 87.9002 153.9 87.1002C154.5 86.8002 154.8 86.3002 154.8 85.9002C154.8 85.5002 154.5 85.0002 153.9 84.7002C153.2 84.2002 152.3 84.1002 151.5 84.1002Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M178.8 84.5004C177.8 84.5004 176.8 84.3004 176.1 83.8004C175.3 83.3004 174.9 82.7004 174.9 82.0004C174.9 81.3004 175.3 80.7004 176.1 80.2004C177.6 79.3004 180 79.3004 181.6 80.2004C182.4 80.7004 182.8 81.3004 182.8 82.0004C182.8 82.7004 182.4 83.3004 181.6 83.8004C180.8 84.3004 179.8 84.5004 178.8 84.5004ZM178.8 80.3004C177.9 80.3004 177.1 80.5004 176.4 80.9004C175.8 81.2004 175.5 81.7004 175.5 82.1004C175.5 82.5004 175.8 83.0004 176.4 83.3004C177.7 84.1004 179.9 84.1004 181.2 83.3004C181.8 83.0004 182.1 82.5004 182.1 82.1004C182.1 81.7004 181.8 81.2004 181.2 80.9004C180.5 80.5004 179.7 80.3004 178.8 80.3004Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M197.6 85.6C196.6 85.6 195.6 85.4 194.9 84.9C194.1 84.4 193.7 83.8 193.7 83.1C193.7 82.4 194.1 81.8 194.9 81.3C196.4 80.4 198.8 80.4 200.4 81.3C201.2 81.8 201.6 82.4 201.6 83.1C201.6 83.8 201.2 84.4 200.4 84.9C199.6 85.4 198.6 85.6 197.6 85.6ZM197.6 81.4C196.7 81.4 195.9 81.6 195.2 82C194.6 82.3 194.3 82.8 194.3 83.2C194.3 83.6 194.6 84.1 195.2 84.4C196.5 85.2 198.7 85.2 200 84.4C200.6 84.1 200.9 83.6 200.9 83.2C200.9 82.8 200.6 82.3 200 82C199.4 81.6 198.5 81.4 197.6 81.4Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M194 83.3004L182.4 82.6004C182.2 82.6004 182.1 82.4004 182.1 82.2004C182.1 82.0004 182.2 81.9004 182.5 81.9004L194.1 82.6004C194.3 82.6004 194.4 82.8004 194.4 83.0004C194.3 83.1004 194.2 83.3004 194 83.3004Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M155 85.7002C154.8 85.7002 154.7 85.6002 154.7 85.4002C154.7 85.2002 154.8 85.1002 155 85.0002L175.3 82.2002C175.5 82.2002 175.6 82.3002 175.7 82.5002C175.7 82.7002 175.6 82.8002 175.4 82.9002L155 85.7002Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M150.5 84.1006C150.4 84.1006 150.3 84.0006 150.2 83.9006L147.6 78.6006C147.5 78.4006 147.6 78.2006 147.7 78.2006C147.9 78.1006 148.1 78.2006 148.1 78.3006L150.7 83.6006C150.8 83.8006 150.7 84.0006 150.6 84.0006C150.6 84.1006 150.5 84.1006 150.5 84.1006Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M143.2 76.5002L132.8 75.4002C132.6 75.4002 132.5 75.2002 132.5 75.0002C132.5 74.8002 132.7 74.7002 132.9 74.7002L143.2 75.8002C143.4 75.8002 143.5 76.0002 143.5 76.2002C143.5 76.3002 143.4 76.5002 143.2 76.5002Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M125.8 74.4008L116.3 73.0008C116.1 73.0008 116 72.8008 116 72.6008C116 72.4008 116.2 72.3008 116.4 72.3008L125.8 73.7008C126 73.7008 126.1 73.9008 126.1 74.1008C126.1 74.3008 126 74.4008 125.8 74.4008Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M110.7 70.7004C110.6 70.7004 110.6 70.7004 110.5 70.6004L106.1 67.1004C106 67.0004 105.9 66.8004 106 66.6004C106.1 66.5004 106.3 66.4004 106.5 66.5004L110.9 70.0004C111 70.1004 111.1 70.3004 111 70.5004C110.9 70.7004 110.8 70.7004 110.7 70.7004Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 65.4004L88 65.0004C87.8 65.0004 87.7 64.8004 87.7 64.7004C87.7 64.5004 87.9 64.4004 88 64.4004L100.5 64.8004C100.7 64.8004 100.8 65.0004 100.8 65.1004C100.8 65.3004 100.7 65.4004 100.5 65.4004Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-24.3988 101.441) scale(205.009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00233891,
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00243891,
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156766,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0606675,
    stopColor: "#59CCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1112,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1662,
    stopColor: "#258D81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#147065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2957,
    stopColor: "#104F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#013F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#01342D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614,
    stopColor: "#01342D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.378 161.915) scale(363.122)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1022,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3445,
    stopColor: "#59CCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7534,
    stopColor: "#258D81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#013F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01342D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 14.7774,
    y1: 75.9587,
    x2: 275.232,
    y2: 75.9587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01342D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949797,
    stopColor: "#013F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2466,
    stopColor: "#258D81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6555,
    stopColor: "#59CCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8978,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7E9E3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1926 100.724) scale(104.938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1022,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3445,
    stopColor: "#59CCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7534,
    stopColor: "#258D81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#013F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01342D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0659 76.5586) scale(216.387)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1022,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3445,
    stopColor: "#59CCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7534,
    stopColor: "#258D81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#013F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01342D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2319 86.9509) scale(177.085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1022,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3445,
    stopColor: "#59CCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7534,
    stopColor: "#258D81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#013F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01342D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1934 87.8546) scale(250.314)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1022,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3445,
    stopColor: "#59CCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7534,
    stopColor: "#258D81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#013F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01342D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.3388 86.9498) scale(317.777)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7E9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1022,
    stopColor: "#88DBD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3445,
    stopColor: "#59CCBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564,
    stopColor: "#12B7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7534,
    stopColor: "#258D81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#013F37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01342D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphs);
export default __webpack_public_path__ + "static/media/graphs.fac42d51703cb5b84776352e7ec198e8.svg";
export { ForwardRef as ReactComponent };